import { render, staticRenderFns } from "./ExampleVirtualVisit.vue?vue&type=template&id=5a6418c1"
import script from "./ExampleVirtualVisit.vue?vue&type=script&lang=js"
export * from "./ExampleVirtualVisit.vue?vue&type=script&lang=js"
import style0 from "./ExampleVirtualVisit.vue?vue&type=style&index=0&id=5a6418c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports